module.exports = __webpack_public_path__ + "img/bank-bg.0fd64c35.svg";